var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('category-picker',{attrs:{"label":_vm.label,"disabled":_vm.disabled,"show-category-path":false},on:{"input":_vm.relay},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }